<mat-card>
    <mat-card-title class="card-title">
        <h5 appLocalizationPopupDirective localizationCode="TimeOffType">{{ 'TimeOffType' | translate: {Default: "Time Off Type"} }}</h5>

        <button
            type="button"
            color="warn"
            mat-icon-button
            aria-label="Delete time off type"
            appPreventDoubleClick
            (throttledClick)="deleteType()"
            *ngIf="timeOffTypeId"
            matTooltip="Delete time off type"
            class="delete-button"
        >
            <mat-icon class="material-icons-outlined">delete</mat-icon>
        </button>
    </mat-card-title>
    <mat-card-content>
        <app-form-generator
            [formId]="formId"
            [formData]="formData"
            [emitFormDataTrigger]="getFormData"
            (emitFormData)="formDataEmitted($event)"
            (emitFormStatus)="formStatusUpdated($event)"
            (emitFormPristine)="formPristineEmitted($event)"
        ></app-form-generator>

        <div class="form-section-title">
            <h6 appLocalizationPopupDirective localizationCode="TimeOffIcon">{{ 'TimeOffIcon' | translate: {Default: "Time Off Icon"} }}</h6>
        </div>
        <div class="k-mb-3">
            <div *ngIf="filePath && filePath !== ''; else noImage">
                <img [src]="domSanitizer.bypassSecurityTrustUrl(filePath)" class="timeoff-type-icon">
            </div>
            <ng-template #noImage>
                <div class="no-image"></div>
            </ng-template>
        </div>

        <div class="k-mb-3">
            <button type="button" mat-raised-button appPreventDoubleClick (throttledClick)="fileInput.click()">Choose File</button>
            <input hidden type="file" accept="image/*" #fileInput (change)="imagePreview($event)"/>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button 
            type="button" 
            setColor="primaryColour" 
            color="primary"
            mat-raised-button 
            appPreventDoubleClick 
            (throttledClick)="getFormData = !getFormData">
            {{ 'Save' | translate: {Default: "Save"} }}
        </button>
    </mat-card-actions>
</mat-card>